var _excluded = ["placeholder", "onTagClose", "onClear"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import { Input, AdornedInput, Adornment, IconSearch } from '@zillow/constellation';
var StyledSearchIcon = styled(IconSearch).withConfig({
  displayName: "SearchInput__StyledSearchIcon",
  componentId: "sc-10221wc-0"
})(["font-size:21px;"]);

var SearchInput = function SearchInput(_ref) {
  var placeholder = _ref.placeholder,
      onTagClose = _ref.onTagClose,
      onClear = _ref.onClear,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(AdornedInput, {
    input: /*#__PURE__*/React.createElement(Input // id={undefined} prevents chrome autocomplete display
    , _extends({
      id: undefined,
      "data-testid": "property-search-input",
      placeholder: placeholder
    }, props)),
    rightAdornment: /*#__PURE__*/React.createElement(Adornment, null, /*#__PURE__*/React.createElement(StyledSearchIcon, {
      fontColor: "brand"
    }))
  });
};

export default SearchInput;
//# sourceMappingURL=SearchInput.js.map